import {Form, formsStore} from '../../../../stores/Form';

export const handleFocusAction = async (currentForm: Form, columnIndex: number) => {
    return formsStore.currentScreen?.onFieldFocusChange(
        {
            newCellIndex: columnIndex,
            newRowIndex: currentForm.currentRow,
            level: currentForm.level
        },
        async () => {
            currentForm.setCurrentColumnIdByIndex(columnIndex);
            currentForm.setCurrentRow(currentForm.currentRow);

            const activeSubForm = currentForm.activeSubForm;

            if (activeSubForm) {
                activeSubForm.resetRecords();
            }
        }
    );
};
